import { LoginFunction } from 'components/providers/loginContext';
import { ENDPOINT_CODE } from 'constants/constants';
import { getAPI } from 'utils/commonService';

export type Code = {
  query: string;
};

// リソースオーナーの認可要求に必要なコードを取得する
export async function getCode(
  loginContext: LoginFunction,
  redirectUri: string,
): Promise<Code> {
  const params = { redirectUri };
  return (await getAPI(ENDPOINT_CODE, loginContext, params)) as Code;
}
